module.exports = __webpack_public_path__ + "media/images/icons/courses/1-92feeccee7820d2ad6df0133bc95b746.svg";